// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__wiCgR","footer":"Form_footer__3_V2r"};